import React, { Component } from 'react';
import { connect } from 'react-redux';
import { togglePanel, destroyToken, } from './../redux/actions';
import SidePanelHeader from './SidePanelHeader';
import NavigationContainer from './NavigationContainer';
import {authSelector} from "../redux/selectors";

class HeaderContainer extends Component {
    render() {
        return (
            <header id="header">
                <div id="leftPanelHeader">
                    <SidePanelHeader
                      title="USERS ONLINE"
                      toggle={this.props.toggleLeft}
                     />
                </div>
                <NavigationContainer
                    auth={this.props.auth}
                    loginOpen={this.props.panel.loginPanelOpen}
                    registerOpen={this.props.panel.registerPanelOpen}
                    currentUser={this.props.auth.currentUser}
                    logout={this.props.logout}
                />
                <div id="rightPanelHeader">
                    <SidePanelHeader
                      title="ACTIVITY FEED"
                      toggle={this.props.toggleRight}
                     />
                </div>
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: authSelector(state),
        panel: state.panel,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleLeft: () => dispatch(togglePanel('left')),
        toggleRight: () => dispatch(togglePanel('right')),
        logout: () => dispatch(destroyToken()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);


// WEBPACK FOOTER //
// ./src/App/HeaderContainer.js